export default "__VITE_ASSET__CrDuLYGc__"